<div class="box box-info">
  <div class="box-header with-border">
    <h3 class="box-title">Ticket {{ ticket?.id }}</h3>
  </div>
  <!-- /.box-header -->
  @if (ticket) {
    <div class="box-body box-profile">
      <h3 class="profile-username text-center">{{ ticket.username }}</h3>
      <p class="text-muted text-center">Elapsed Time</p>
      <h2 class="text-center" style="margin-top: 8px;">
        {{ hours }} Hours {{ minutes }} Minutes
      </h2>
      <ul class="list-group list-group-unbordered">
        <li class="list-group-item">
          <b>Enter time</b>
          <a class="pull-right">{{ ticket.in_time | date: "dd/MM/yyyy h:mm a" }}</a>
        </li>
        <li class="list-group-item">
          <b>Exit time</b>
          <a class="pull-right">{{ ticket.out_time | date: "dd/MM/yyyy h:mm a" }}</a>
        </li>
        <li class="list-group-item">
          <b>Car</b>
          <a class="pull-right">{{ ticket.vehicle.title }}</a>
        </li>
        <li class="list-group-item">
          <b>Plate</b>
          <a class="pull-right"
            >{{ ticket.vehicle.plate_number_prefix }}
            {{ ticket.vehicle.plate_number }}</a
            >
          </li>
          <li class="list-group-item">
            <b>Parking place</b>
            <a class="pull-right">{{ ticket.parking_units.title }}</a>
          </li>
          <li class="list-group-item">
            <b>Area</b>
            <a class="pull-right">{{ ticket.parking_units.area }}</a>
          </li>
        </ul>
      </div>
    }
  </div>
